const KEY = 'velora_daily'
const today = () => new Date().toISOString().slice(0, 10)

const CHALLENGES = [
  { id: 'free',      icon: '🎤', title: 'Free Practice',    desc: 'Any session counts today!',           xp: 10 },
  { id: 'warmup',    icon: '🌅', title: 'Morning Warmup',   desc: 'Complete a warmup session',           xp: 15 },
  { id: 'song',      icon: '🎵', title: 'Sing a Song',      desc: 'Practice a song from your list',      xp: 20 },
  { id: 'range',     icon: '📊', title: 'Vocal Range Test', desc: 'Complete your vocal range test',      xp: 25 },
  { id: 'accuracy',  icon: '🎯', title: 'Hit 80% Accuracy', desc: 'Score 80%+ in any session',           xp: 20 },
  { id: 'scales',    icon: '🎼', title: 'Practice Scales',  desc: 'Complete a scales warmup session',    xp: 15 },
  { id: 'streak',    icon: '🔥', title: 'Keep the Streak',  desc: 'Complete any practice today',         xp: 10 },
]

export interface DailyChallenge {
  date: string
  id: string
  icon: string
  title: string
  desc: string
  xp: number
  completed: boolean
}

export function getDailyChallenge(): DailyChallenge {
  const d = today()
  try {
    const stored = localStorage.getItem(KEY)
    if (stored) {
      const p: DailyChallenge = JSON.parse(stored)
      if (p.date === d) return p
    }
  } catch { /* ignore */ }
  const ch = { ...CHALLENGES[new Date().getDay()], date: d, completed: false }
  localStorage.setItem(KEY, JSON.stringify(ch))
  return ch
}

export function completeDailyChallenge(minScore = 0): number {
  const d = today()
  try {
    const stored = localStorage.getItem(KEY)
    if (!stored) return 0
    const p: DailyChallenge = JSON.parse(stored)
    if (p.date !== d || p.completed) return 0
    // accuracy challenge needs 80%+
    if (p.id === 'accuracy' && minScore < 80) return 0
    p.completed = true
    localStorage.setItem(KEY, JSON.stringify(p))
    return p.xp
  } catch { return 0 }
}
